export type WeekStyleConfig = {
  bgColor: string;
  color: string;
  fontSize: string;
};

export const defaultWeekStyleConfig: WeekStyleConfig = {
  bgColor: 'primary.500',
  color: 'white',
  fontSize: 'xs',
};
